import { render } from "./statsSpecial.vue?vue&type=template&id=08ab15d8&scoped=true"
import script from "./statsSpecial.vue?vue&type=script&lang=js"
export * from "./statsSpecial.vue?vue&type=script&lang=js"

import "./statsSpecial.vue?vue&type=style&index=0&id=08ab15d8&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ab15d8"]])

export default __exports__